// Personalizar chatbot — orquestrador; lógica em features/customization/
import React from "react";
import { useCustomizationState } from "../features/customization/useCustomizationState";
import { styles } from "../features/customization/customizationStyles";
import { CustomizationMessageBanner } from "../features/customization/CustomizationMessageBanner";
import { CustomizationSelectors } from "../features/customization/CustomizationSelectors";
import { CustomizationAppearanceSection } from "../features/customization/CustomizationAppearanceSection";
import { CustomizationTextsSection } from "../features/customization/CustomizationTextsSection";
import { CustomizationLlmSection } from "../features/customization/CustomizationLlmSection";
import { CustomizationWidgetPreview } from "../features/customization/CustomizationWidgetPreview";
import { CustomizationHelpVideo } from "../features/customization/CustomizationHelpVideo";

const Customization = ({ user }) => {
  const vm = useCustomizationState({ user });
  const {
    isAdmin,
    selectedBot,
    customization,
    setCustomization,
    message,
    handleChange,
    handleSubmit,
  } = vm;

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Personalizar Chatbot</h2>

      <CustomizationMessageBanner message={message} styles={styles} />

      <CustomizationSelectors vm={vm} styles={styles} />

      {selectedBot && (
        <div style={styles.formAndPreview}>
          <form onSubmit={handleSubmit} style={styles.form}>
            <CustomizationAppearanceSection
              customization={customization}
              handleChange={handleChange}
              styles={styles}
            />
            <CustomizationTextsSection
              customization={customization}
              handleChange={handleChange}
              styles={styles}
            />
            {isAdmin && (
              <CustomizationLlmSection
                customization={customization}
                setCustomization={setCustomization}
                styles={styles}
              />
            )}
            <button type="submit" style={styles.button}>
              Salvar Customização
            </button>
          </form>
          <CustomizationWidgetPreview customization={customization} styles={styles} />
        </div>
      )}

      <CustomizationHelpVideo styles={styles} />
    </div>
  );
};

export default Customization;
